import type { LinkEntity as LinkEntityProps } from "components/base-entity-link/types";

type Item = {
  isBold?: boolean;
} & LinkEntityProps;

export type FooterMenuData = Item[];

export const footerMenuData: FooterMenuData[] = [
  [
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      name: "Video",
      routeType: "Page",
      urlAlias: "/video/posties",
    },
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      name: "ePaper",
      routeType: "Page",
      urlAlias: "/epaper",
    },
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      name: "Little Journalist",
      routeType: "Page",
      urlAlias: "/",
    },
    {
      entityId: "",
      entityUuid: "",
      isBold: true,
      name: "Events",
      routeType: "Page",
      urlAlias: "/",
    },
  ],
  [
    {
      entityId: "",
      name: "Subscribe",
      urlAlias: "https://subscribe.scmp.com/posties",
    },
    {
      entityId: "",
      entityUuid: "",
      name: "About us",
      routeType: "Static",
      urlAlias: "/posties/about-us",
    },
    {
      entityId: "",
      entityUuid: "",
      name: "Contact us",
      routeType: "Static",
      urlAlias: "/posties/contact-us",
    },
    {
      entityId: "800172",
      entityUuid: "d1c18b93-cb6c-48a2-bf84-7c2acb96d4cc",
      name: "Privacy Policy",
      routeType: "Page",
      urlAlias: "/privacy-policy",
    },
    {
      entityId: "800173",
      entityUuid: "c18b91b9-6e24-45dc-ba05-974848666e4b",
      name: "Terms & Conditions",
      routeType: "Page",
      urlAlias: "/terms-conditions",
    },
  ],
];
